<template>
  <div class="profile-section">
    <img :src="instructor.img_url || '/default-avatar.png'" alt="Instructor Profile" class="instructor-image">
    <div class="instructor-info">
      <h1>{{ instructor?.first_name }} {{ instructor?.last_name }}</h1>
      <div class="rating">
        <span class="stars">
          <i class="fas fa-star"></i> {{ instructor.rating || 'N/A' }}
        </span>
        <span class="reviews">({{ instructor.total_reviews || 0 }} reviews)</span>
      </div>
    </div>
    <button @click="$emit('edit-profile')" class="primary-button edit-profile-button">
      <i class="fas fa-edit"></i> Edit Instructor
    </button>
  </div>
</template>

<script>
export default {
  name: 'InstructorProfile',
  props: {
    instructor: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.profile-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.instructor-image {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.instructor-info h1 {
  margin: 0 0 0.5rem;
  color: #1e293b;
  font-size: 2rem;
}

.rating {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #64748b;
  font-size: 1rem;
}

.stars {
  color: #eab308;
  font-weight: 600;
}

.edit-profile-button {
  margin-left: auto;
}

@media (max-width: 768px) {
  .profile-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .instructor-info {
    margin-top: 1rem;
    margin-left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .edit-profile-button {
    margin-left: 0;
    margin-top: 1rem;
  }
}
</style> 